import { useEffect, useState } from 'react';
import type { IntimacyState } from '../../../hooks/useIntimacy';

interface IntimacyBarProps {
  state: IntimacyState;
  progressPercent: number;
  showLevelUp?: boolean;
  onLevelUpAnimEnd?: () => void;
}

export default function IntimacyBar({
  state,
  progressPercent,
  showLevelUp,
  onLevelUpAnimEnd,
}: IntimacyBarProps) {
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (showLevelUp) {
      setAnimating(true);
      const t = setTimeout(() => {
        setAnimating(false);
        onLevelUpAnimEnd?.();
      }, 2000);
      return () => clearTimeout(t);
    }
  }, [showLevelUp, onLevelUpAnimEnd]);

  const dots = [1, 2, 3, 4, 5] as const;

  return (
    <div className="px-4 py-2 flex items-center gap-3 relative bg-white/8 backdrop-blur-sm border-b border-white/10">
      {/* レベルドット */}
      <div className="flex items-center gap-1">
        {dots.map((d) => (
          <div
            key={d}
            className="w-2 h-2 rounded-full transition-all duration-500"
            style={{
              backgroundColor: d <= state.level ? state.color : 'rgba(255,255,255,0.2)',
              transform: d === state.level && animating ? 'scale(1.6)' : 'scale(1)',
              boxShadow: d === state.level ? `0 0 6px ${state.color}80` : 'none',
            }}
          />
        ))}
      </div>

      {/* プログレスバー */}
      <div className="flex-1 h-1.5 bg-white/20 rounded-full overflow-hidden backdrop-blur-sm">
        <div
          className="h-full rounded-full transition-all duration-700 ease-out"
          style={{
            width: `${progressPercent}%`,
            backgroundColor: state.color,
            boxShadow: `0 0 8px ${state.color}60`,
          }}
        />
      </div>

      {/* ラベル */}
      <div className="flex items-center gap-1 whitespace-nowrap">
        <span className="text-xs drop-shadow-sm">{state.emoji}</span>
        <span
          className="text-xs font-medium transition-colors duration-500 drop-shadow-sm"
          style={{ color: state.color }}
        >
          {state.label}
        </span>
      </div>

      {/* レベルアップ演出 */}
      {animating && (
        <div
          className="absolute left-1/2 -translate-x-1/2 top-10 z-50 px-5 py-2 rounded-full text-white text-xs font-bold shadow-lg animate-bounce backdrop-blur-sm"
          style={{ backgroundColor: state.color }}
        >
          {state.emoji} 親密度アップ！ {state.label}
        </div>
      )}
    </div>
  );
}
